export default "__VITE_ASSET__d4f84cdf__"